export default {"src":"/_next/static/media/logo.5d07ff7f.svg","height":157,"width":689};